import { render, staticRenderFns } from "./weiYan.vue?vue&type=template&id=31db7d60&scoped=true&"
import script from "./weiYan.vue?vue&type=script&lang=js&"
export * from "./weiYan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db7d60",
  null
  
)

export default component.exports